export enum QUERY_KEYS {
  createBoxOffice = 'create-box-office',
  getBoxOffice = 'get-box-office',
}
